//@ts-check
import React from 'react';
import FrameBase from '../../frame/FrameBase';
import Extensions from '../../apps/Extensions';
/**@param {import('./types').EngagementPreviewFrameProps} props */

var EngagementPreview = function EngagementPreview(_ref) {
  var journeyId = _ref.journeyId,
      touchpointId = _ref.touchpointId,
      contactId = _ref.contactId,
      threadId = _ref.threadId,
      width = _ref.width,
      height = _ref.height,
      onThreadCountClick = _ref.onThreadCountClick;
  var url = 'embed/EngagementPreview/#engage/Journeys/' + journeyId;
  if (touchpointId !== null) url += '/' + touchpointId;

  if (contactId && threadId) {
    url = 'embed/EngagementPreview/#engage/Contact/' + contactId + '/' + journeyId + '/' + threadId;
  }

  var onEvent = function onEvent(event) {
    switch (event.action) {
      case 'click-score':
        onThreadCountClick && onThreadCountClick(event.data);
        break;

      default:
        break;
    }
  };

  return React.createElement(React.Fragment, null, journeyId && React.createElement(Extensions, {
    extensionFor: "JourneyPreview",
    id: journeyId
  }), React.createElement(FrameBase, {
    useEcrionServer: true,
    url: url,
    width: width,
    height: height,
    namespace: "Engagement",
    on: onEvent,
    style: {
      minHeight: 600
    }
  }));
};

EngagementPreview.defaultProps = {
  width: '100%',
  height: 'auto',
  touchpointId: null
};
export default EngagementPreview;